// 토론 주제 목록 (톤별 분류: light=가벼운, medium=보통, deep=철학적/묵직한)
export const debateTopics = [
    // 가벼운 주제 (light) - 토론할 거리가 있는 것들
    { text: "첫눈에 사랑은 존재할까?", tone: "light" },
    { text: "고백은 타이밍인가 진심인가?", tone: "light" },
    { text: "이별 후 우정이 가능할까?", tone: "light" },
    { text: "질투는 사랑의 증거인가?", tone: "light" },
    { text: "거짓말도 사랑일까?", tone: "light" },
    { text: "사랑은 감정일까 행동일까?", tone: "light" },
    { text: "연인과 친구의 차이는 무엇일까?", tone: "light" },
    { text: "호감과 사랑의 경계는 어디일까?", tone: "light" },
    { text: "관계에서 솔직함과 배려, 어느 쪽이 더 중요할까?", tone: "light" },
    { text: "사랑할 때와 사랑받을 때, 어느 쪽이 더 행복할까?", tone: "light" },
    { text: "연애에서 적극적인 사람과 소극적인 사람, 누가 더 행복할까?", tone: "light" },
    { text: "이상형과 현실형, 어느 쪽을 선택해야 할까?", tone: "light" },
    { text: "관계에서 갈등은 피해야 할까, 마주해야 할까?", tone: "light" },
    { text: "사랑은 시간이 지나면 변하는 걸까?", tone: "light" },
    { text: "첫사랑은 특별한 걸까, 그냥 기억일 뿐일까?", tone: "light" },
    
    // 보통 주제 (medium)
    { text: "사랑은 노력인가 타이밍인가?", tone: "medium" },
    { text: "사랑은 희생인가 선택인가?", tone: "medium" },
    { text: "진짜 사랑은 기다리는 것인가 붙잡는 것인가?", tone: "medium" },
    { text: "사랑보다 꿈이 먼저일까?", tone: "medium" },
    { text: "사랑과 우정의 경계는 무엇인가?", tone: "medium" },
    { text: "사랑할 때와 사랑받을 때, 어느 쪽이 더 행복할까?", tone: "medium" },
    { text: "사람은 정말 변할 수 있는 존재일까?", tone: "medium" },
    { text: "후회 없는 삶이 가능할까?", tone: "medium" },
    { text: "운명은 존재하는가?", tone: "medium" },
    { text: "성공은 운인가 실력인가?", tone: "medium" },
    { text: "행복은 선택인가 결과인가?", tone: "medium" },
    { text: "변화는 필연인가 선택인가?", tone: "medium" },
    { text: "진실이 항상 정답일까?", tone: "medium" },
    { text: "가족보다 사랑이 우선일 수 있을까?", tone: "medium" },
    { text: "도덕은 절대적인가 상대적인가?", tone: "medium" },
    { text: "가난은 노력 부족인가 운의 문제인가?", tone: "medium" },
    { text: "꿈이 평생 하나일 필요가 있을까?", tone: "medium" },
    { text: "행복한 삶엔 돈이 꼭 필요할까?", tone: "medium" },
    { text: "실패는 성장인가 낙인인가?", tone: "medium" },
    { text: "항상 강한 사람이 이길까?", tone: "medium" },
    { text: "평범한 삶도 가치 있는 삶일까?", tone: "medium" },
    { text: "사랑은 결국 선택일까, 운명일까?", tone: "medium" },
    { text: "꿈은 포기해도 될까?", tone: "medium" },
    { text: "과거를 잊는 게 진짜 치유일까?", tone: "medium" },
    { text: "사랑은 희생을 포함해야 할까?", tone: "medium" },
    { text: "운명은 받아들이는 걸까, 바꾸는 걸까?", tone: "medium" },
    { text: "사람은 고통을 통해 성장해야 할까?", tone: "medium" },
    { text: "진실보다 거짓 위로가 더 따뜻할 수 있을까?", tone: "medium" },
    { text: "희망은 사람을 살리는가, 망치는가?", tone: "medium" },
    { text: "운명은 존재하는가, 만들어가는가?", tone: "medium" },
    // 철학적/묵직한 주제 (deep)
    { text: "과거를 잊는 것이 진짜 용서일까?", tone: "deep" },
    { text: "자유의지가 존재할까?", tone: "deep" },
    { text: "의미 있는 삶이란 무엇인가?", tone: "deep" },
    { text: "인간은 왜 존재하는가?", tone: "deep" },
    { text: "진정한 자유란 무엇인가?", tone: "deep" },
    { text: "희생은 가치 있을까?", tone: "deep" },
    { text: "완벽함은 가능한가?", tone: "deep" },
    { text: "욕망은 나쁜 것일까?", tone: "deep" },
    { text: "고통은 성장에 필요한가?", tone: "deep" },
    { text: "진정한 용기는 무엇인가?", tone: "deep" },
    { text: "과거, 현재, 미래 중 어느 것이 가장 중요할까?", tone: "deep" },
    { text: "누군가를 구하기 위해 또 다른 누군가를 버릴 수 있을까?", tone: "deep" },
    { text: "이기적인 사람도 이해받을 수 있을까?", tone: "deep" },
    { text: "사람은 왜 상처를 주면서까지 사랑하는가?", tone: "deep" },
    { text: "진실과 거짓의 경계는 어디인가?", tone: "deep" },
    { text: "인간의 본성은 선한가 악한가?", tone: "deep" },
    { text: "인간은 이기적인 존재일까?", tone: "deep" },
    { text: "관계에서 가장 중요한 것은 무엇인가?", tone: "deep" },
    { text: "정의는 누가 정하는가?", tone: "deep" },
    { text: "정의란 무엇인가?", tone: "deep" },
    { text: "시간은 존재하는가?", tone: "deep" },
    { text: "현실과 환상의 차이는 무엇인가?", tone: "deep" },
    { text: "죽음은 끝인가 시작인가?", tone: "deep" },
    { text: "사랑은 결국 힘싸움인가?", tone: "deep" },
    { text: "진짜 어른은 어떤 사람일까?", tone: "deep" },
    { text: "후회 없다는 말은 사실 거짓일까?", tone: "deep" },
    { text: "사람은 결국 '본성'대로 살아갈까?", tone: "deep" },
    { text: "사랑보다 중요한 감정이 존재할까?", tone: "deep" },
    { text: "'운명'은 선택의 다른 이름일까?", tone: "deep" },
    { text: "진짜 용서는 어떤 순간에 시작될까?", tone: "deep" },
    { text: "고통은 사람을 성장시키는 걸까, 망치는 걸까?", tone: "deep" },
    { text: "기억이 사라져도 사랑은 남을까?", tone: "deep" },
    { text: "타인을 위해 자신을 포기하는 건 옳을까?", tone: "deep" },
    { text: "후회는 삶의 일부일까, 실수일까?", tone: "deep" },
    { text: "행복은 조건일까, 태도일까?", tone: "deep" },
    { text: "인생에 하나의 정답은 존재할까?", tone: "deep" },
    { text: "평범함과 특별함 중에 뭘 선택해야 할까?", tone: "deep" },
    { text: "무언가를 지키기 위해 버리는 건 불가피할까?", tone: "deep" },
    { text: "진짜 용서는 가능한가?", tone: "deep" },
    { text: "사람은 고통을 겪어야 성장할까?", tone: "deep" },
    { text: "선한 사람도 상황이 바뀌면 악해질까?", tone: "deep" },
    { text: "외로움은 피해야 할 감정일까, 필요한 감정일까?", tone: "deep" },
    { text: "성공은 끝까지 포기하지 않는 사람에게 오는 걸까?", tone: "deep" },
    { text: "진짜 친구는 '어떤 상황에서도' 이해해주는 사람일까?", tone: "deep" },
    { text: "우리가 내리는 선택은 진짜 우리의 선택일까?", tone: "deep" },
    { text: "사람은 자신의 모든 행동에 끝까지 책임져야 할까?", tone: "deep" },
    { text: "기억이 사라지면 그 사람은 같은 사람일까?", tone: "deep" },
    { text: "행복은 '목표'일까, '과정'일까?", tone: "deep" },
    { text: "죄책감은 사람을 바꾸는 힘이 있을까?", tone: "deep" },
    { text: "행복하지 않아도 꿈은 계속해야 할까?", tone: "deep" },
    { text: "운명은 정해져 있는 걸까, 만들어가는 걸까?", tone: "deep" },
    { text: "고통은 인간을 더 인간답게 만들까?", tone: "deep" },
    { text: "사람은 왜 살아야 할까? 죽지 않고 살아야 하는 이유가 있을까?", tone: "deep" },
    { text: "기억이 고통뿐이라면 잊는 게 맞을까, 안고 살아야 할까?", tone: "deep" },
    { text: "사랑은 사람을 구원할까, 파괴할까?", tone: "deep" },
    { text: "우리는 근본적으로 선한 존재일까? 아니면 악한 존재일까?", tone: "deep" },
    { text: "내가 내린 선택은 정말 '내 의지'일까? 환경이 만든 결과일까?", tone: "deep" },
    { text: "고통은 인간에게 꼭 필요한 감정일까?", tone: "deep" },
    { text: "두 번째 기회는 누구에게나 주어져야 할까?", tone: "deep" },
    { text: "희망은 현실을 버티게 해줄까, 오히려 눈을 가릴까?", tone: "deep" },
    { text: "후회가 사람을 성장시키는 걸까, 파괴하는 걸까?", tone: "deep" },
    { text: "진짜 용서는 '과거를 잊는 것'일까, '기억하면서 받아들이는 것'일까?", tone: "deep" },
    { text: "가끔은 진실보다 '거짓 위로'가 더 필요할 때가 있는 걸까?", tone: "deep" },
    { text: "사람은 결국 혼자일까? 아니면 누군가와 연결되어야만 존재할까?", tone: "deep" },
    { text: "나는 내가 생각하는 '나'일까? 남들이 보는 '나'일까?", tone: "deep" },
    { text: "사람은 왜 사랑받고 싶을까?", tone: "deep" },
    { text: "욕망은 인간을 살아있게 하는가, 아니면 망가뜨리는가?", tone: "deep" },
    { text: "사람은 결국 자기 자신을 구원할 수 있을까?", tone: "deep" },
    { text: "사랑은 기적일까, 환상일까?", tone: "deep" },
    { text: "인생의 정답은 있는 걸까? 아니면 스스로 만들어가는 걸까?", tone: "deep" },
    { text: "'행복해지고 싶다'는 마음도 결국 욕심일까?", tone: "deep" },
    { text: "가장 진짜 나다운 순간은 언제일까?", tone: "deep" },
    { text: "행복해지는 순간이 내가 꿈꾸던 순간이 아닐 수 있다는 걸 받아들일 수 있을까?", tone: "deep" },
    { text: "누군가에게 상처 주지 않고는 진짜 나답게 살 수 없는 걸까?", tone: "deep" },
    { text: "사랑받기 위해 노력하는 '나'는 진짜 '나'일까?", tone: "deep" },
    { text: "사람은 혼자서도 버틸 수 있어야 할까 아니면 혼자 버티는 건 잘못된 걸까?", tone: "deep" },
    { text: "'나는 괜찮아'라고 말하는 순간 진짜 괜찮아지는 걸까?", tone: "deep" },
    { text: "지나온 과거가 지금의 나를 만든 거라면 과거를 미워하는 건 나를 미워하는 걸까?", tone: "deep" },
    { text: "내가 나를 위로할 수 없다면 누구에게 위로를 받아야 할까?", tone: "deep" },
    { text: "정말 중요한 선택 앞에서 '아무것도 선택하지 않는 것'도 선택일까?", tone: "deep" },
    { text: "사람은 왜 굳이 '의미'를 찾아야 할까? 그냥 살아도 되는 걸까?", tone: "deep" },
    { text: "정말 괜찮다면 왜 자꾸 스스로에게 괜찮냐고 묻는 걸까?", tone: "deep" },
    { text: "내 감정은 나에게 속하는 걸까? 아니면 타인의 영향으로 만들어지는 걸까?", tone: "deep" },
    { text: "사람은 왜 '이유'를 찾지 않으면 불안할까?", tone: "deep" },
    { text: "결국 삶은 질문이고, 죽음만 답일까?", tone: "deep" },
    { text: "우리가 만든 선택이 우리를 만드는 걸까?", tone: "deep" },
    { text: "하나의 진실보다 여러 개의 거짓이 삶을 더 살아지게 하는 걸까?", tone: "deep" },
    { text: "내가 '나'임을 확신할 수 있는 근거는 무엇일까?", tone: "deep" },
    { text: "우리가 경험하는 현실은 진짜 현실일까, 아니면 해석된 현실일까?", tone: "deep" },
    { text: "사랑이 없다면 인간은 인간일 수 있을까?", tone: "deep" },
    { text: "언젠가 모두 잊히는 존재라면 살아가는 이유는 어디에 있을까?", tone: "deep" },
    { text: "기억이 나를 만든다면, 잊어버린 나는 사라진 걸까?", tone: "deep" },
    { text: "자유로운 선택이 정말 가능할까? 아니면 모든 선택은 이미 결정되어 있을까?", tone: "deep" },
    { text: "진리에 가까워진다는 건 고통에 가까워진다는 뜻 아닐까?", tone: "deep" },
    { text: "행복이 무엇인지 모르는 상태에서도 우리는 행복할 수 있을까?", tone: "deep" },
    { text: "사람은 왜 혼자 있는 순간을 견디지 못할까?", tone: "deep" },
    { text: "'괴로움'이란 감정은 진짜일까? 아니면 뇌가 만들어낸 환상일까?", tone: "deep" },
    { text: "왜 우리는 생각하면서도 '생각하지 않으려고' 할까?", tone: "deep" },
    { text: "우리가 무언가를 믿는 순간, 그것이 진실이 되는 걸까?", tone: "deep" },
    { text: "'괜찮아'라는 말은 감정을 사라지게 만드는 주문일까?", tone: "deep" },
    { text: "사람은 '이해받는 것'보다 '이해하고 싶어 하는 욕구'를 더 크게 가질까?", tone: "deep" },
    { text: "상처가 사람을 바꾸는 걸까? 아니면 본래 모습이 드러나는 걸까?", tone: "deep" },
    { text: "우리는 왜 '나 말고 다른 나'를 연기하며 살아갈까?", tone: "deep" },
    { text: "혼자 있으면 무너지는데 함께 있어도 무너질 때가 있는 이유는 뭘까?", tone: "deep" },
    { text: "나는 내 감정을 '소유'하고 있는 걸까? 감정이 나를 '소유'하고 있는 걸까?", tone: "deep" },
    { text: "변화가 두려운 건, 변화 때문일까 아니면 그 후의 '나'를 상상할 수 없기 때문일까?", tone: "deep" },
    { text: "사랑하면 바뀌는 건 사람일까? 시선일까?", tone: "deep" },
    { text: "사랑은 결국 소유욕과 구분될 수 있을까?", tone: "deep" },
    { text: "진짜 나답다는 건 '남들과 달라지는 것'일까?", tone: "deep" },
    { text: "사람은 결국 서로를 구원할 수 있을까?", tone: "deep" }
];

